export enum OfferValue {
  None = 'none',
  SemiAnnual = 'semiannual',
  Subscription = 'subscription',
  Trial = 'trial',
}
